import { createSelector } from '@reduxjs/toolkit';
import { getFromImmutableState } from 'src/utils/immutableUtils';
import { getDefaultDeparture } from '@lt/localization';
import { getSearcherDeparture } from './searcher';

const _getDepartures = (state) => state.get('departures');
export const getDepartures = getFromImmutableState(_getDepartures);
export const getSearcherDepartures = createSelector(
  getDepartures,
  (departures) => departures,
);
export const getSelectedFromCity = createSelector(
  [getDepartures, getSearcherDeparture],
  (departures, departureValue) => {
    if (departureValue.id === 0) {
      return {
        id: departureValue.id,
        nameEn: departureValue.name_en,
        nameRu: departureValue.name_ru,
        nameRuForm2: departureValue.name_ru_form2,
      };
    }

    const departure = departures.find((item) => item.id === departureValue.id);

    if (!departure) {
      return getDefaultDeparture();
    }

    return {
      id: departure.id,
      nameEn: departure.name_en,
      nameRu: departure.name_ru,
      nameRuForm2: departure.name_ru_form2,
    };
  },
);
